import React, { Component } from "react";
import PropTypes from "prop-types";
import MdStars from "react-icons/lib/md/stars";

import TruncateText from "../generic/TruncateText";
import SimilarAuthorsEventTypes from 'data/types/SimilarAuthorsEventTypes';
import withLogFeatureUsage from 'react/containers/AnalyticContainer';
import "./similarAuthorsListItem.less";

class SimilarAuthorsListItem extends Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick() {
		this.props.onClick();
		this.props.onItemClick(this.props.author.uniqueId);
	}

	render() {
		return (
			<div className="similar-authors-row clickable" key={this.props.key} onClick={this.handleClick}>
				<MdStars className="similar-authors-row-icon" />
				<div className="similar-authors-row-name">
					<TruncateText line={1} text={this.props.author.authorName} truncateText="..." />
				</div>
			</div>
		);
	}
}

SimilarAuthorsListItem.propTypes = {
	author: PropTypes.object,
	onClick: PropTypes.func,
	onItemClick: PropTypes.func.isRequired
};

export { SimilarAuthorsListItem };

export default withLogFeatureUsage(SimilarAuthorsListItem, SimilarAuthorsEventTypes.SIMILARAUTHOR_LISTNAME_CLICKED, (props) => props.author.uniqueId);



// WEBPACK FOOTER //
// ./src/react/views/similarAuthors/SimilarAuthorsListItem.jsx